import { render } from "./AppHeader.vue?vue&type=template&id=22cd22a8&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=22cd22a8&scoped=true&lang=css"
import "./AppHeader.vue?vue&type=style&index=1&id=22cd22a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cd22a8"]])

export default __exports__